module.exports = __webpack_public_path__ + "static/media/add-favorite-active.ad1b5cbe.svg";